export const TAIWAN_CITIES = [
    '台北市', '新北市', '桃園市', '台中市', '台南市', '高雄市',
    '基隆市', '新竹市', '嘉義市', '新竹縣', '苗栗縣', '彰化縣',
    '南投縣', '雲林縣', '嘉義縣', '屏東縣', '宜蘭縣', '花蓮縣',
    '台東縣', '澎湖縣', '金門縣', '連江縣'
];

// 活動專用縣市清單：多了「線上」選項，供線上舉辦的揪團活動使用
// 注意：探索使用者 (Browse.js / FilterPanel.js) 篩選的是「使用者居住縣市」，不適用「線上」，仍應使用 TAIWAN_CITIES
export const EVENT_CITIES = ['線上', ...TAIWAN_CITIES];
